module.exports = "<div>\n    <h4>{{ error.errorMessage}}</h4>\n    <div style='text-align: center'><strong><h4>{{error.errorCode}}</h4></strong></div>\n    <br><br>\n    <div style='text-align: center'>\n        <a style='cursor:pointer' (click)='reloadPage()'><i class=\"material-icons tooltipped\" data-position=\"bottom\" data-delay=\"50\" data-tooltip=\"Reload page\">replay</i><br>reload</a> \n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/helper-components/error.component.html
// module id = 564
// module chunks = 1